import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "App-User-Top" }
const _hoisted_2 = { class: "App-User-Top-Prof" }
const _hoisted_3 = { class: "App-User-Top-D" }
const _hoisted_4 = { "txt-center": "" }
const _hoisted_5 = { "m-tb-0": "" }
const _hoisted_6 = {
  key: 0,
  "mute-secondary": ""
}
const _hoisted_7 = {
  key: 0,
  "m-tb-1": ""
}
const _hoisted_8 = {
  "m-t-1": "",
  style: {"border-radius":"6px","background":"#eff6f4"}
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  "m-t-3": ""
}
const _hoisted_13 = {
  "f-w-600": "",
  "m-tb-0": ""
}
const _hoisted_14 = {
  key: 0,
  "mute-secondary": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_app_ent_standing = _resolveComponent("app-ent-standing")!
  const _component_app_section_divider = _resolveComponent("app-section-divider")!
  const _directive_blur = _resolveDirective("blur")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isSelf)
            ? (_openBlock(), _createBlock(_component_el_dropdown, {
                key: 0,
                onCommand: _ctx.handleCommand,
                "as-pointer": "",
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, {
                        command: "upload",
                        icon: "el-icon-delete"
                      }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode(" Upload ", -1)
                        ]))]),
                        _: 1
                      }),
                      (_ctx.user.avatar !== undefined)
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: 0,
                            command: "delete",
                            icon: "el-icon-upload"
                          }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode(" Delete ", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_avatar, {
                    "as-pointer": "",
                    size: 180,
                    src: _ctx.user.avatar
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.$filters.initials(_ctx.user)), 1)
                      ])), [
                        [_directive_blur, _ctx.user]
                      ])
                    ]),
                    _: 1
                  }, 8, ["src"])
                ]),
                _: 1
              }, 8, ["onCommand"]))
            : (_openBlock(), _createBlock(_component_el_avatar, {
                key: 1,
                size: 180,
                src: _ctx.user.avatar
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createElementBlock("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$filters.initials(_ctx.user)), 1)
                  ])), [
                    [_directive_blur, _ctx.user]
                  ])
                ]),
                _: 1
              }, 8, ["src"]))
        ]),
        _createElementVNode("div", null, [
          _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1)
          ])), [
            [_directive_blur, _ctx.user]
          ]),
          _createElementVNode("div", null, _toDisplayString(_ctx.user.headline || _ctx.user.areaOfExpertise), 1),
          (_ctx.user.location)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.user.location.description), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (_ctx.user.email)
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  type: "primary",
                  href: `mailto:${_ctx.user.email}`,
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.user.email), 1)
                  ]),
                  _: 1
                }, 8, ["href"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", null, [
          (_ctx.user.about)
            ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.user.about), 1)
              ])), [
                [_directive_blur, _ctx.user]
              ])
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.account.type === 'founder' && _ctx.user.type === 'talent')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_ctx.business)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_app_ent_standing, {
                        labelSelf: `${_ctx.$filters.capitalize(_ctx.business.name)}`,
                        labelOther: `${_ctx.$filters.capitalize(_ctx.user.firstName)}(Talent)`,
                        standingSelf: _ctx.business.standing,
                        standingOther: _ctx.user.standing,
                        size: "medium"
                      }, null, 8, ["labelSelf", "labelOther", "standingSelf", "standingOther"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.account.type === 'talent')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_app_ent_standing, {
                  labelSelf: `${_ctx.$filters.capitalize(_ctx.user.firstName)}(You)`,
                  standingSelf: _ctx.user.standing,
                  size: "medium"
                }, null, 8, ["labelSelf", "standingSelf"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.opportunity && _ctx.business)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_app_section_divider, { content: "Matched Opportunity" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "el-icon-s-opportunity" }, null, -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.opportunity.outcome), 1),
                _createElementVNode("div", null, [
                  (_ctx.opportunity.business)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.business.name), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.loadingPic]
      ])
    ])
  ]))
}